import { Combobox } from '@/components/common/Combobox'

export function PlaceholderPicker({
  value, onChange, options, onClear,
}: {
  value: string
  onChange: (v: string) => void
  options: string[]
  onClear: () => void
}) {
  return (
    <div className="flex items-center gap-1 flex-1">
      <Combobox<string>
        value={value || null}
        onChange={v => onChange(v ?? '')}
        options={options.map(p => ({ value: p, label: p }))}
        placeholder="— zmienna —"
        className="flex-1 text-sm font-mono bg-violet-50"
      />
      <button
        type="button"
        onClick={onClear}
        className="text-xs text-slate-500 hover:text-slate-900 px-1"
        title="Wpisz wartość zamiast zmiennej"
      >literal</button>
    </div>
  )
}
